import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Form,
  InputGroup,
  Spinner,
  Table,
  Modal, // Added Modal for Video Preview
} from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";

const Youtube = () => {
  const navigate = useNavigate();

  const [youtube, setYoutube] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Modal States for Video Player
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState("");
  const [selectedVideoTitle, setSelectedVideoTitle] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    url: "",
  });
  const fetchYoutube = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${API_URL}/api/youtube/get-all-youtube`,
      );
      setYoutube(data || []);
    } catch (error) {
      console.log(error);
      toast.error("Unable to fetch videos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchYoutube();
  }, []);

  const filteredYoutube = useMemo(() => {
    return youtube.filter((item) =>
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [youtube, searchQuery]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredYoutube.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(filteredYoutube.length / recordsPerPage);

  const handleDelete = async (_id) => {
    const token = sessionStorage.getItem("token");
    if (!token) return toast.error("Unauthorized");

    if (!window.confirm("Delete this video?")) return;

    const previous = youtube;
    setYoutube((prev) => prev.filter((item) => item._id !== _id));

    try {
      await axios.delete(`${API_URL}/api/youtube/delete-youtube/${_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Video Deleted");
    } catch (error) {
      setYoutube(previous);
      toast.error(error.response?.data?.message || "Delete Failed");
    }
  };

  const handleStatusToggle = async (_id) => {
    const token = sessionStorage.getItem("token");
    if (!token) return toast.error("Unauthorized");

    setYoutube((prev) =>
      prev.map((item) =>
        item._id === _id
          ? {
              ...item,
              status: item.status === "active" ? "inactive" : "active",
            }
          : item,
      ),
    );

    try {
      await axios.put(
        `${API_URL}/api/youtube/update-youtube-status/${_id}`,
        {
          statusbar:
            youtube.find((item) => item._id === _id)?.status === "active"
              ? "inactive"
              : "active",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success("Status Updated");
    } catch (error) {
      toast.error("Update Failed");
      fetchYoutube();
    }
  };

  // Open Video Modal Handler
  const openVideoPlayer = (youtubeId, title) => {
    setSelectedVideoId(youtubeId);
    setSelectedVideoTitle(title);
    setShowVideoModal(true);
  };

  const extractYoutubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);

    // Agar link match ho jata hai aur ID ki length 11 hai, toh sirf ID bhejega (e.g. dQw4w9WgXcQ)
    return match && match[2].length === 11 ? match[2] : null;
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("token");
    if (!token) return toast.error("Unauthorized! Please login again.");

    // YouTube ID validation
    const videoId = formData.url;
    if (!videoId) {
      return toast.error("Please enter a valid YouTube URL!");
    }

    try {
      setSubmitting(true);

      // Backend API ko data bhej rahe hain
      // Note: Aapka backend agar pure link accept karta hai ya direct ID, uske hisab se payload bhejein
      const payload = {
        title: formData.title,
        youtubeId: videoId, // Extracted ID
        url: formData.url,
        status: "active", // Default status
      };

      await axios.post(`${API_URL}/api/youtube/create-youtube`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Video Added Successfully!");

      // Form reset aur modal close
      setFormData({ title: "", url: "" });
      setShowCreateModal(false);

      // List refresh karein
      fetchYoutube();
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Failed to add video.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-layout-wrapper ">
      {/* Top Header */}
      <Header />

      <div className="admin-main-container">
        {/* Navigation Sidebar */}
        <Sidebar />
        <div fluid className="youtube-create-page-content mt-5">
          {/* Dashboard Header */}
          <Card className="shadow-sm border-0 rounded-4 mb-4">
            <Card.Body>
              <Row className="align-items-center">
                <Col lg={8}>
                  <h2 className="fw-bold mb-2">
                    <i className="bi bi-youtube text-danger me-2"></i>
                    Youtube Dashboard
                  </h2>
                  <p className="text-muted mb-0">
                    Manage your Youtube videos cleanly.
                  </p>
                </Col>
                <Col lg={4} className="text-lg-end mt-3 mt-lg-0">
                  <Link to="#" onClick={() => setShowCreateModal(true)}>
                    <Button
                      variant="danger"
                      size="lg"
                      className="rounded-pill px-4"
                      // onClick={() => setShowCreateModal(true)}
                    >
                      <i className="bi bi-plus-circle me-2"></i> Add Video
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Cards Row */}
          <Row className="g-4 mb-4">
            <Col md={4}>
              <Card className="shadow border-0 rounded-4">
                <Card.Body>
                  <h6 className="text-muted">Total Videos</h6>
                  <h2 className="fw-bold">{filteredYoutube.length}</h2>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow border-0 rounded-4">
                <Card.Body>
                  <h6 className="text-muted">Active</h6>
                  <h2 className="fw-bold text-success">
                    {youtube.filter((item) => item.status === "active").length}
                  </h2>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow border-0 rounded-4">
                <Card.Body>
                  <h6 className="text-muted">Inactive</h6>
                  <h2 className="fw-bold text-secondary">
                    {
                      youtube.filter((item) => item.status === "inactive")
                        .length
                    }
                  </h2>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Search bar */}
          <Card className="shadow-sm border-0 rounded-4 mb-4">
            <Card.Body>
              <InputGroup>
                <InputGroup.Text className="bg-white border-end-0">
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search youtube title..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="border-start-0 shadow-none"
                />
              </InputGroup>
            </Card.Body>
          </Card>

          {/* Main Table */}
          <Card className="shadow border-0 rounded-4 overflow-hidden">
            <Card.Body className="p-0">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "350px" }}
                >
                  <Spinner animation="border" variant="danger" />
                </div>
              ) : (
                <div className="table-responsive">
                  <Table hover className="align-middle mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th style={{ width: "70px" }}>#</th>
                        <th style={{ width: "140px" }}>Thumbnail</th>
                        <th>Title</th>
                        <th style={{ width: "150px" }}>Posted On</th>
                        <th style={{ width: "150px" }}>Status</th>
                        <th style={{ width: "180px" }} className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.length > 0 ? (
                        currentRecords.map((b, index) => (
                          <tr key={b._id}>
                            <td className="fw-semibold">
                              {firstIndex + index + 1}
                            </td>
                            <td>
                              {/* Hover Play Icon Thumbnail Design */}
                              <div
                                className="position-relative overflow-hidden rounded shadow-sm bg-dark"
                                style={{
                                  width: "110px",
                                  height: "65px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  openVideoPlayer(b.videoUrl, b.title)
                                }
                              >
                                <img
                                  src={
                                    b?.blogImage?.url ||
                                    `https://img.youtube.com/vi/${b.videoUrl}/mqdefault.jpg`
                                  }
                                  alt="thumbnail"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    if (
                                      e.target.src !==
                                      "https://via.placeholder.com/110x65?text=No+Image"
                                    ) {
                                      e.target.src =
                                        "https://via.placeholder.com/110x65?text=No+Image";
                                    }
                                  }}
                                />
                                <div
                                  className="position-absolute top-50 start-50 translate-middle text-white bg-danger rounded-circle px-2 py-1 shadow-lg"
                                  style={{ opacity: 0.9 }}
                                >
                                  <i className="bi bi-play-fill fs-5"></i>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div
                                className="fw-semibold text-truncate"
                                style={{ maxWidth: "320px" }}
                              >
                                {b.title}
                              </div>
                            </td>
                            <td>
                              {b.createdAt
                                ? new Date(b.createdAt).toLocaleDateString(
                                    "en-IN",
                                  )
                                : "--"}
                            </td>
                            <td>
                              <Badge
                                bg={
                                  b.status === "active"
                                    ? "success"
                                    : "secondary"
                                }
                                className="px-3 py-2 rounded-pill"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleStatusToggle(b._id)}
                              >
                                {b.status}
                              </Badge>
                            </td>
                            <td className="text-center">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="me-2"
                                as={Link}
                                // to={`/update/youtube/${b._id}`}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDelete(b._id)}
                              >
                                <i className="bi bi-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center py-5">
                            No Videos Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>
          {!loading && totalPages > 1 && (
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4 gap-3 bg-white p-3 rounded-4 shadow-sm">
              {/* Left Side: Entries Counter */}
              <div className="text-muted order-2 order-sm-1 fs-6">
                Showing <strong className="text-dark">{firstIndex + 1}</strong>{" "}
                to{" "}
                <strong className="text-dark">
                  {lastIndex > filteredYoutube.length
                    ? filteredYoutube.length
                    : lastIndex}
                </strong>{" "}
                of{" "}
                <strong className="text-dark">{filteredYoutube.length}</strong>{" "}
                videos
              </div>

              {/* Right Side: Responsive Navigation Buttons */}
              <nav className="order-1 order-sm-2">
                <ul className="pagination pagination-md mb-0 justify-content-center flex-wrap">
                  {/* First Page */}
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(1)}
                    >
                      <i className="bi bi-chevron-double-left"></i> First
                    </button>
                  </li>

                  {/* Previous Page */}
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      Previous
                    </button>
                  </li>

                  {/* Dynamic Numbered Pages */}
                  {Array.from({ length: totalPages }).map((_, index) => {
                    const pageNum = index + 1;
                    return (
                      <li
                        key={index}
                        className={`page-item ${currentPage === pageNum ? "active" : ""}`}
                      >
                        <button
                          className="page-link shadow-none"
                          onClick={() => setCurrentPage(pageNum)}
                          style={
                            currentPage === pageNum
                              ? {
                                  backgroundColor: "#dc3545",
                                  borderColor: "#dc3545",
                                }
                              : {}
                          }
                        >
                          {pageNum}
                        </button>
                      </li>
                    );
                  })}

                  {/* Next Page */}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>

                  {/* Last Page */}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      Last <i className="bi bi-chevron-double-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={showVideoModal}
        onHide={() => setShowVideoModal(false)}
        size="lg"
        centered
        className="rounded-4"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title
            className="fs-5 fw-bold text-truncate"
            style={{ maxWidth: "85%" }}
          >
            {selectedVideoTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 bg-dark overflow-hidden">
          <div className="ratio ratio-16x9">
            {showVideoModal && (
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideoId}?autoplay=1&rel=0`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCreateModal}
        onHide={() => !submitting && setShowCreateModal(false)} // Prevent close during submit
        centered
        backdrop="static" // User bahar click karke galti se close na kare
      >
        <Modal.Header closeButton={!submitting} className="bg-light">
          <Modal.Title className="fw-bold fs-5">
            <i className="bi bi-plus-circle-fill text-danger me-2"></i>
            Add New YouTube Video
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleCreateSubmit}>
          <Modal.Body className="py-4">
            {/* INPUT 1: TITLE */}
            <Form.Group className="mb-3" controlId="formVideoTitle">
              <Form.Label className="fw-semibold text-dark">
                Video Title
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter an catchy title for the video..."
                required
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
                className="py-2"
              />
            </Form.Group>

            {/* INPUT 2: YOUTUBE LINK */}
            <Form.Group className="mb-3" controlId="formYoutubeLink">
              <Form.Label className="fw-semibold text-dark">
                YouTube Link / URL
              </Form.Label>
              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <i className="bi bi-link-45deg text-muted"></i>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="e.g., dQw4w9WgXcQ"
                  required
                  value={formData.url}
                  onChange={(e) =>
                    setFormData({ ...formData, url: e.target.value })
                  }
                  className="py-2"
                />
              </InputGroup>
              <Form.Text className="text-muted">
                Use only last Id After = Example: watch?v=dQw4w9WgXcQ
              </Form.Text>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="bg-light border-top-0">
            <Button
              variant="secondary"
              onClick={() => setShowCreateModal(false)}
              disabled={submitting}
              className="px-3"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              type="submit"
              disabled={submitting}
              className="px-4"
            >
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving...
                </>
              ) : (
                "Save Video"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Youtube;
